import React from "react";
import { Row } from "react-grid-system";

export const MarginLeftRow = (props) => (
  <Row 
    {...props} 
    style={{
      ...(props.style || {}),
      marginLeft: "-30px",
      marginRight: "0",
    }} 
  />
);

export const NoMarginRow = (props) => (
  <Row 
    {...props} 
    style={{
      ...(props.style || {}),
      marginLeft: "0",
      marginRight: "0",
    }} 
  />
);